import { useState } from "react";

export const useAccordion = () => {
  const [isOpen, setIsOpen] = useState(true);
  const handleToggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return { isOpen, handleToggleOpen };
};
